export const RECOVER_MODE = 'recover';
export const LOGIN_MODE = 'login';
export const SIGNUP_MODE = 'signup';
export const RESEND_MODE = 'resend';

export type AuthMode = typeof RECOVER_MODE | typeof LOGIN_MODE | typeof SIGNUP_MODE | typeof RESEND_MODE;

export const isRecoverMode = (mode: AuthMode) => mode === RECOVER_MODE;
export const isSignupMode = (mode: AuthMode) => mode === SIGNUP_MODE;
export const isLoginMode = (mode: AuthMode) => mode === LOGIN_MODE;
export const isResendMode = (mode: AuthMode) => mode === RESEND_MODE;
